import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout/layout";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Services } from "../../Services";
import { toast } from "react-toastify";
// import AddCategory from "./AddCategory";
// eslint-disable-next-line
import AddCategory from "./addcoupons";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";

import Moment from "react-moment";
import swal from "sweetalert";
function Warehouse() {
    const Navigate = useNavigate();

    const [params, setparams] = useSearchParams();
    const [tableLoad, setTableLoad] = useState(false);
    const [pageCount, setpageCount] = useState(1);
    const [category, setCategory] = useState(false);

    const [editable, setEditable] = useState(false);
    const [categoryItems, setCategoryItems] = useState([]);
    const [categorysearchItems, setCategorySearchItems] = useState([]);

    let [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const categoryHandler = () => {
        setCategory((prev) => !prev);
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const getcategories = () => {
        Services.getCoupons("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setCategoryItems(res.Coupons);
                    setCategorySearchItems(res.Coupons);
                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        getcategories();

        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
        }

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
            console.log("11");
        }, 150);
        return () => {
            clearTimeout(timer);
        };
    }, [categorysearchItems]);

    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        console.log(id);
        swal("Are You sure you want to Delete?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    Services.deleteCoupen("POST", null, token, id)
                        .then((res) => {
                            if (res.Status === 1) {
                                getcategories();
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    const statusFormatter = (cell) => {
        let classname =
            cell === "Active"
                ? dashboardclasses["status_active"]
                : dashboardclasses["status_inactive"];
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <p className={classname}>{cell}</p>
            </div>
        );
    };
    const ActionFormatter = (cell, cellcontent) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setEditable(cellcontent);
                        setCategory(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
                <button onClick={deleteHandler} id={cellcontent._id}>
                    <MdDelete size={18} />
                </button>
            </div>
        );
    };
    const columns = [
        {
            dataField: "name",
            text: "NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "couponType",
            text: "TYPE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "couponfor",
            text: "COUPON FOR",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "value",
            text: "VALUE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "minOrderValue",
            text: "MIN ORDER VALUE",
            sort: false,
            formatter: (cell) => {
                return `₹ ${cell}`;
            },
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "maxDiscount",
            text: "MAX DISCOUNT",
            sort: false,
            formatter: (cell) => {
                return `₹ ${cell}`;
            },
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },
        {
            dataField: "startDate",
            text: "START DATE",
            sort: false,
            formatter: (cell) => {
                return <Moment format="DD-MM-YYYY">{cell}</Moment>;
            },
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },
        {
            dataField: "endDate",
            text: "END DATE",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },

        {
            dataField: "status",
            text: "STATUS",
            sort: false,
            formatter: statusFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
    ];
    const pagination = paginationFactory({
        page: pageCount,
        sizePerPage: 8,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
            window.scrollTo({ top: 10, behavior: "instant" });
            Navigate(`/Coupons?page=${page}`);
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log("page", page);
            console.log("sizePerPage", sizePerPage);
        },
    });
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        setTableLoad(true);
        setparams({ page: 1 });
        setpageCount(1);
        const search = categoryItems.filter((item) =>
            item.name.toLowerCase().includes(e.target.value.toLowerCase())
        );
        // console.log(search);
        setCategorySearchItems(search);
    };
    return (
        <>
            {category && (
                <AddCategory
                    setmodal={setCategory}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                />
            )}

            <Layout Active={"Coupons"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Coupons</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by name"
                                        onChange={searchHandler}
                                    />

                                    <button onClick={categoryHandler}>
                                        + Add Coupon
                                    </button>
                                </div>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={categorysearchItems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            pagination={pagination}
                                            wrapperClasses="table-responsive"
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
